export const I18N = {
    de: {
        notFound: 'Es wurden keine Einträge gefunden.',
        notEnoughChars: 'Bitte geben Sie mindestens {} Zeichen ein.'
    },
    en: {
        notFound: 'No entries matching were found.',
        notEnoughChars: 'Please enter more than {} characters'
    }
};
